module.exports = __webpack_public_path__ + "img/6-icono-completados.4f86e034.svg";